import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGoogleAnalytics } from 'hooks/useGoogleAnalytics';
import { useKiosk } from 'hooks/useKiosk';
import { getProductsRoute } from 'hooks/useRouting';

import { Bounty } from 'types/bounty.interface';

const useBountyDetails = () => {
  const [selectedBounty, setSelectedBounty] = useState<Bounty|null>(null);
  const { handleTrackViewItem } = useGoogleAnalytics();
  const { kioskMode } = useKiosk();
  const navigate = useNavigate();

  const openBountyDetails = (bounty: Bounty) => {
    setSelectedBounty(bounty);

    if (!kioskMode) {
      handleTrackViewItem(bounty);
    }
  };

  const closeBountyDetails = () => {
    setSelectedBounty(null);
  };

  const handleViewBounties = (bounties: Bounty[]) => {
    if (bounties?.length === 1) {
      openBountyDetails(bounties[0]);
      return;
    }

    const queryParams = bounties
      .map(({ id }) => `bountyIds=${id.trim()}`)
      .join('&');

    navigate(getProductsRoute(queryParams));
  };

  return {
    selectedBounty,
    openBountyDetails,
    closeBountyDetails,
    onViewBounties: handleViewBounties,
  };
};

export default useBountyDetails;
